import React from "react";

// plugin imports
import { useTranslation } from "@herob191/gatsby-plugin-react-i18next";

// style imports
import "./navMenu.scss";

// component imports
import { LayoutContext } from "../../../context/layoutContext";

// util imports

// svg imports

// component
export default function NavMenuButton() {
	const { t } = useTranslation();

	const { navMenuOpen, setNavMenuOpen } = React.useContext(LayoutContext);

	return (
		<>
			<button
				className={`navMenuButton ${navMenuOpen ? "menuOpen" : ""}`}
				onClick={() => setNavMenuOpen(!navMenuOpen)}
				aria-label={t("Abrir/cerrar menú de navegación")}
			>
				<span />
				<span />
				<span />
			</button>
		</>
	);
}
